import { render, staticRenderFns } from "./spreadsheet.vue?vue&type=template&id=3184f0d4&lang=pug&"
import script from "./spreadsheet.vue?vue&type=script&lang=js&"
export * from "./spreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./spreadsheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports